export const InvalidTrackingReferenceType = 'invalid_tracking_reference';

const TrackingPageOverrideTypes = [
  InvalidTrackingReferenceType,
];

export default TrackingPageOverrideTypes;
